export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/timer_worker.worker.93b50a8e.worker.js");
}
